import {
	GET_LIST_CATEGORIES,
	GET_DETAIL_CATEGORIES,
	ADD_CATEGORIES,
	UPDATE_CATEGORIES,
    DELETE_CATEGORIES,
    CATEGORIES_ERROR,
    SUBMITING_CATEGORIES,
    NEW_CATEGORIES,
	FETCHING_CATEGORIES,
	GET_OPTION_LIST_CATEGORIES
} from '../constants';

/**
 * Initial State
 */
const initialState={
	list:[],
	options:[],
	detail:{},
	isFetch:false,
	isSubmit:false,
	error:null,
	success:null,
}

/**
 * Function to manipulate payload when success get offer list
 * @author pewe
 * @param {object} lastState 
 * @param {object} payload 
 */
const onGetCategoriesList = (lastState,payload) => {
	const {data, message, status_code}=payload;
	return { ...lastState, error:null, success:null,detail:{}, list:{ ...data, message, status_code } };	
}

/**
 * Function to manipulate payload when success get offer details
 * @author pewe
 * @param {object} lastState 
 * @param {object} payload 
 */
const onGetDetailCategories = (lastState,payload) => {
	const {data, message, status_code}=payload;
	return { ...lastState, error:null, success:null, detail:{ ...data, message, status_code } };	
}

/**
 * Function to handle when start or end fetching offer api
 * @author pewe
 * @param {object} lastState 
 * @param {objec} bool 
 */
const onFetchingCategories = (lastState,payload) => {
    if(payload.type==='fetch')
        return { ...lastState, isFetch:payload.status }
    else if(payload.type==='submit')
        return { ...lastState, isSubmit:payload.status }

    return { ...lastState, isFetch:false,isSubmit:false }
}

/**
 * Function to handle when fetching offer error triggered
 * @author pewe
 * @param {object} lastState 
 * @param {object} error 
 */
const onCategoriesError = (lastState,error) => {
	return { ...lastState, ...error, success:null };		
}

const onAddCategories = (lastState,payload) => {
	const {data, message, status_code}=payload;
    return { ...lastState, detail:{ ...data, message, status_code }, success:'Insert has been successfully!',error:null }
}

const onUpdateCategories = (lastState,payload) => {
	const {data, message, status_code}=payload;
    return { ...lastState, detail:{ ...data, message, status_code }, success:'Update has been successfully!',error:null }
	
}
const onDeleteCategories = (lastState,payload) => {
	const {data, message, status_code}=payload;
    return { ...lastState, detail:{ ...data, message, status_code, delete:true }, success:'Delete has been successfully!',error:null }
}

const onGetOption=(lastState,payload)=>{
	const {data, message, status_code}=payload;
	const options = data.map((item)=>{
		return {value:item.id,label:item.name}
	});
    return { ...lastState, options, success:null,error:null }

}
/**
 * Offer Reducer
 * @author pewe
 * @param {object} state 
 * @param {object} action 
 */
const categoriesReducer= (state=initialState, action) => {
	switch(action.type)
	{
		case GET_LIST_CATEGORIES: return onGetCategoriesList(state,action.payload);
		case GET_DETAIL_CATEGORIES: return onGetDetailCategories(state,action.payload);
		case FETCHING_CATEGORIES: return onFetchingCategories(state,action.payload);
		case CATEGORIES_ERROR:return onCategoriesError(state,action.payload);
		case UPDATE_CATEGORIES:return onUpdateCategories(state,action.payload);
		case ADD_CATEGORIES:return onAddCategories(state,action.payload);
		case DELETE_CATEGORIES:return onDeleteCategories(state,action.payload);
		case GET_OPTION_LIST_CATEGORIES:return onGetOption(state,action.payload);
		case NEW_CATEGORIES:return initialState;
		default:return state;
	}
}

export default categoriesReducer;